import { render, staticRenderFns } from "./subledger.vue?vue&type=template&id=7b6c5e56&scoped=true&"
import script from "./subledger.vue?vue&type=script&lang=js&"
export * from "./subledger.vue?vue&type=script&lang=js&"
import style0 from "./subledger.vue?vue&type=style&index=0&id=7b6c5e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6c5e56",
  null
  
)

export default component.exports